module.exports = __webpack_public_path__ + "res/4-img_game_bg_q_b.f44dd1ed6041026666ad8fed622820ef.png";